import axios from 'axios'
import { EventEmitter } from 'events'
import { toaster, history, ls } from '../index'

let baseURL = process.env.REACT_APP_API_URL
const cookieName = process.env.REACT_APP_AUTH_COOKIE || 'cademyAdminToken'
const EDUCATOR_CONTEXT_NAME = 'educatorContext'

const emitter = new EventEmitter()

let loginRedirectURL = `${process.env.REACT_APP_PUBLIC_URL}/login`

const requestService = {
  setAuthToken: (token) => {
    const currentToken = requestService.getAuthToken()
    if (currentToken === token) {
      return
    }
    if (token) {
      ls.setItem(cookieName, token)
      emitter.emit('auth:token_changed', token)
    } else {
      ls.removeItem(cookieName)
      emitter.emit('auth:token_changed', null)
    }
  },
  setLoginRedirectURL: (redirectURL) => {
    loginRedirectURL = redirectURL
  },
  getAuthToken: () => {
    return ls.getItem(cookieName)
  },

  getEducatorContext: () => {
    return ls.getItem(EDUCATOR_CONTEXT_NAME)
  },

  onTokenChange: (callback) => {
    emitter.on('auth:token_changed', callback)
    return () => {
      emitter.removeListener('auth:token_changed', callback)
    }
  },
  setBaseUrl: (baseUrl) => (baseURL = baseUrl),
  post: (url, _body, opts) => {
    const body = JSON.stringify(_body)
    return requestService.request('post', url, body, opts)
  },
  delete: (url, opts) => {
    return requestService.request('delete', url, null, opts)
  },
  get: (url, opts) => {
    return requestService.request('get', url, null, opts)
  },
  request: (method = 'get', url = '/', body = null, opts = {}) => {
    const defaultHeaders = {
      'Content-Type': 'application/json'
    }
    const authToken = requestService.getAuthToken()
    if (authToken) {
      defaultHeaders['Authorization'] = `Bearer ${authToken}`
    }

    const educatorContext = requestService.getEducatorContext()
    if (educatorContext && educatorContext.length > 0) {
      defaultHeaders['Educator-Context'] = educatorContext
    }

    opts = Object.assign(
      {},
      {
        headers: defaultHeaders,
        handleErrors: true
      },
      opts
    )
    return axios({
      method,
      url,
      baseURL,
      data: body,
      headers: opts.headers,
      withCredentials: true
    })
      .then((res) => {
        if (
          opts.ignore_refresh_token !== true &&
          res.headers['x-refresh-token']
        ) {
          requestService.setAuthToken(res.headers['x-refresh-token'])
        }
        return res
      })
      .catch((err) => {
        if (!opts.handleErrors) throw err
        if (err.response) {
          if (err.response.data.statusCode === 401) {
            console.log('! 401 ! - The API said the token has expired')
            requestService.setAuthToken('')
            if (history.location.pathname !== '/login') {
              window.location.href = `${loginRedirectURL}?redirect=${encodeURIComponent(
                window.location.href
              )}`
            }
          } else if (Array.isArray(err?.response?.data?.safe)) {
            toaster.danger(
              err.response.data.safe.join(', '),
              undefined,
              undefined,
              err
            )
          } else if (err.response.data.description) {
            toaster.danger(
              err.response.data.description,
              undefined,
              undefined,
              err
            )
          } else if (err.response.data.title) {
            toaster.danger(
              err.response.data.detail || err.response.data.title,
              undefined,
              undefined,
              err
            )
          } else {
            throw err
          }
        }

        if (err && err.response && err.response.data) {
          window.analytics.track('Handled Request error', err.response.data)
        } else {
          window.analytics.track('Unhandled Request error', {
            stack: err.stack,
            message: err.toString(),
            fullError: JSON.stringify(err, Object.getOwnPropertyNames(err))
          })
        }

        throw err
      })
  }
}

export default requestService
